import { IconButton, Spinner } from '@material-tailwind/react';
import React, { useState } from 'react';
import { useGetUGroups } from '../../custom-hooks/use-user-groups';
import { EyeIcon, PencilIcon, TrashIcon } from 'lucide-react';
import UserGroupsFormModal from './userGroupsFormModal';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../components';

const INITIAL_FORM_DATA = {
    name: '',
    description: '',
    recipients: [],
    routes: [],
    urls: [],
    apis: [],
    functions: []
};

const UserGroups = () => {
    const [openAddUserModalState, setOpenAddUserModalState] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [formData, setFormData] = useState(INITIAL_FORM_DATA);
    const { data: userGroups, isLoading: isUserGroupsLoading, error: userGroupsError } = useGetUGroups();
    const [selectedUserGroupId, setSelectedUserGroupId] = useState(null);

    // Open modal for adding a new user
    const openAddUserModal = () => {
        setOpenAddUserModalState(true);
        setFormData(INITIAL_FORM_DATA);
        setIsUpdating(false);
    };

    // Open modal for updating a user
    const openUpdateUserModal = (user) => {
        setOpenAddUserModalState(true);
        setFormData({
            ...user,
            password: '' // Clear password field for security
        });
        setIsUpdating(true);
        setSelectedUserGroupId(user._id);
    };

    return (
        <div className='m-4 p-4 border rounded-3xl'>
            <PageHeader
                title="User Group Management"
                isLoading={isUserGroupsLoading}
                actionOnClick={openAddUserModal}
                actionType="add"
                actionText="Add New User Group"
            />

            <div className='mt-4'>
                <div className='overflow-x-auto'>
                    {
                        isUserGroupsLoading ?
                            <div className='flex justify-center items-center h-full'>
                                <Spinner />
                            </div>
                            : userGroupsError ?
                                <div className='flex justify-center items-center h-full'>
                                    <p className='text-red-500'>{userGroupsError.message}</p>
                                </div>
                                :
                                <table className="w-full min-w-max table-auto text-left">
                                    <thead className="text-sm">
                                        <tr className="py-3">
                                            <th colSpan={6} className="py-3 text-xs font-light text-orange-900">
                                                List of All User Groups ({userGroups?.length || 0})
                                            </th>
                                        </tr>
                                        <tr className="py-3 uppercase">
                                            <th className="py-3">Group Name</th>
                                            <th className="py-3">Description</th>
                                            <th className="py-3">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            userGroups?.map((userGroup) => (
                                                <tr key={userGroup._id} className="border-t hover:bg-gray-50 button rounded-full">
                                                    <td className="font-thin py-3 text-sm">{userGroup.name}</td>
                                                    <td className="font-thin py-3 text-sm">{userGroup.description}</td>
                                                    <td className="py-3 flex gap-1">
                                                        <Link to={`/user-groups/${userGroup._id}`}>
                                                            <IconButton variant='gradient' color='blue' className='rounded-full'>
                                                                <EyeIcon size={12} />
                                                            </IconButton>
                                                        </Link>
                                                        <IconButton variant='gradient' color='orange' className='rounded-full' onClick={() => openUpdateUserModal(userGroup)}>
                                                            <PencilIcon size={12} />
                                                        </IconButton>
                                                        <IconButton variant='gradient' color='red' className='rounded-full'>
                                                            <TrashIcon size={12} />
                                                        </IconButton>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                    }
                </div>
            </div>
            {
                openAddUserModalState &&
                <UserGroupsFormModal
                    open={openAddUserModalState}
                    onClose={() => setOpenAddUserModalState(false)}
                    onSubmit={() => { }}
                    isUpdating={isUpdating}
                    defaultData={formData}
                    selectedUserGroupId={selectedUserGroupId}
                />
            }
        </div>
    );
};

export default UserGroups;